var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Report generation" },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function ({ fileResults }) {
              return [
                fileResults && fileResults.length > 0
                  ? _c(
                      "PrimaryBtn",
                      {
                        staticClass: "my-2 ml-0 mr-2",
                        attrs: { icon: "save_alt" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadResults(fileResults)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("Button.DownloadAnyway")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "PrimaryBtn",
        {
          staticClass: "my-2 ml-0 mr-2",
          attrs: { loading: _vm.loading, icon: "save_alt" },
          on: {
            click: function ($event) {
              return _vm.generateReportAsync()
            },
          },
        },
        [_vm._v("\n    Asynchronous Generate Report\n  ")]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          attrs: { type: "info", dismissible: "" },
          model: {
            value: _vm.alert,
            callback: function ($$v) {
              _vm.alert = $$v
            },
            expression: "alert",
          },
        },
        [
          _vm._v(
            "\n    Report generation request is submitted. Please check the status of the process at the "
          ),
          _c("a", { on: { click: _vm.goToMessageCenter } }, [
            _vm._v("message center"),
          ]),
          _vm._v(".\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }